/* Sunkissed (Nov 1 2026): browse a product's photos from its card.
   Desktop: arrows on hover. The hover photo counts as photo 2, the arrows carry on from the photo you see,
   and leaving the card puts the cover back. Photos load from /products/<handle>.js on first hover.
   Phones: no arrows. The theme's own swipe gets up to 5 more photos (listed by the card in data-sk-more). */
(function () {
  'use strict';
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var cache = {};
  function imgs(h) {
    if (cache[h]) return cache[h];
    cache[h] = fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      return p ? (p.media || []).filter(function (m) { return m.media_type === 'image'; }).map(function (m) { var s = m.src || (m.preview_image && m.preview_image.src) || ''; return s.indexOf('//') === 0 ? 'https:' + s : s; }) : [];
    }).catch(function () { return []; });
    return cache[h];
  }
  function base(u) { return (u || '').split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.)/, ''); }
  function url(u, w) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  /* ---------- desktop arrows ---------- */
  function setup(box) {
    if (box.getAttribute('data-sk-arrows') || (+box.getAttribute('data-sk-imgs') || 0) < 3) return;
    box.setAttribute('data-sk-arrows', '1');
    var h = box.getAttribute('data-sk-handle'), list = null, i = 0, orig = null, busy = 0;
    var img = function () { return box.querySelector('[data-product-image-default] img'); };
    function count() {
      var c = box.querySelector('.sk-arr-count');
      if (!c) { c = document.createElement('span'); c.className = 'sk-arr-count'; box.appendChild(c); }
      c.textContent = (i + 1) + ' / ' + list.length;
    }
    function reset() {
      var im = img();
      if (orig && im) { im.src = orig.src; if (orig.srcset) im.setAttribute('srcset', orig.srcset); if (orig.sizes) im.setAttribute('sizes', orig.sizes); }
      box.classList.remove('sk-browsing');
      var c = box.querySelector('.sk-arr-count'); if (c) c.remove();
      list = null; busy++;
    }
    function go(step) {
      imgs(h).then(function (arr) {
        var im = img(); if (!arr.length || !im) return;
        if (!list) {
          list = arr;
          orig = { src: im.getAttribute('src'), srcset: im.getAttribute('srcset'), sizes: im.getAttribute('sizes') };
          /* start from the photo on screen: the hover photo while hovering, else the cover */
          var hov = box.querySelector('[data-hover-slide] img');
          var seen = (box.matches(':hover') && hov) ? (hov.currentSrc || hov.src) : (im.currentSrc || im.src);
          i = Math.max(0, list.findIndex(function (u) { return base(u) === base(seen); }));
        }
        i = (i + step + list.length) % list.length;
        var want = i, u = url(list[i], 800), token = busy;
        var pre = new Image(); pre.src = u;
        var swap = function () {
          if (want !== i || token !== busy || !list) return;
          im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.removeAttribute('loading'); im.src = u;
          box.classList.add('sk-browsing');
        };
        if (pre.decode) pre.decode().then(swap, swap); else { pre.onload = swap; pre.onerror = swap; }
        count();
      });
    }
    ['prev', 'next'].forEach(function (dir) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'sk-arr sk-arr--' + dir; b.setAttribute('aria-label', dir === 'prev' ? 'Previous photo' : 'Next photo');
      b.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="' + (dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(dir === 'next' ? 1 : -1); });
      box.appendChild(b);
    });
    box.addEventListener('mouseenter', function () {
      imgs(h).then(function (arr) { arr.slice(0, 12).forEach(function (u) { var p = new Image(); p.src = url(u, 800); }); });
    });
    box.addEventListener('mouseleave', reset);
  }

  /* ---------- phone swipe: more photos ---------- */
  function more(el) {
    if (el.getAttribute('data-sk-more-done')) return;
    var slider = el.querySelector('[data-hover-slider]'); if (!slider) return;
    el.setAttribute('data-sk-more-done', '1');
    var tpl = slider.querySelector('[data-hover-slide-touch]'); if (!tpl) return;
    var tf = tpl.querySelector('figure'), figCls = (tf && tf.className) || 'image-wrapper image-wrapper--cover', figSt = (tf && tf.getAttribute('style')) || '';
    el.getAttribute('data-sk-more').split('|').forEach(function (u) {
      if (!u) return;
      var d = document.createElement('div'); d.className = 'product-item__bg__slide'; d.setAttribute('data-hover-slide-touch', '');
      d.innerHTML = '<figure class="' + figCls.replace(/lazy-image\S*/g, '') + '" style="' + figSt.replace(/"/g, '&quot;') + '"><img src="' + u + '" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover"></figure>';
      slider.appendChild(d);
    });
    el.style.setProperty('--slides-count', slider.children.length);
  }

  function scan() {
    if (fine) {
      document.querySelectorAll('[data-product-image][data-sk-handle]').forEach(function (b) { if (b.getBoundingClientRect().width) setup(b); });
    } else {
      document.querySelectorAll('hover-images[data-sk-more]').forEach(more);
    }
  }
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 300); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
})();
